import { t } from 'i18next';
import { ObjectSchema } from 'yup';
import { PhoneCountryCodeType } from '@bus/models';
import { ContactPersonFormModel_OL } from './formModel';
import { CorrespondenceMethodEnum, TitleEnum } from '../../../../../types/forms';
import { getEnumValues } from '../../../../../services/common/miscUtils';
import Yup, {
  minMobileNumberLength,
  maxMobileNumberLength,
  regExEmail,
} from '../../../../../services/common/validation';

export const getValidationSchema = (): ObjectSchema<Partial<ContactPersonFormModel_OL>> => {
  return Yup.object({
    title: Yup.string().required(t('validation:required')).oneOf(getEnumValues(TitleEnum)),
    firstName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    lastName: Yup.string().requiredWithMsg().unaccentedLetters().lengthBetween(0, 64),
    jobTitle: Yup.string().requiredWithMsg(),
    countryCode: Yup.string().requiredWithMsg().oneOf(getEnumValues(PhoneCountryCodeType)),
    phoneNumber: Yup.string().requiredWithMsg().lengthBetween(minMobileNumberLength, maxMobileNumberLength),
    email: Yup.string().requiredWithMsg().matches(regExEmail, t('validation:invalidEmail')),
    correspondenceMethod: Yup.string().requiredWithMsg().oneOf(getEnumValues(CorrespondenceMethodEnum)),
  });
};
